export default __webpack_public_path__ + "static/uniswap-40bd58d8a3f7ce6a48a502999b239180.png";